import { Form, Formik } from "formik";
import { Tab, Tabs } from "@mui/material";
import _ from "lodash";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import InitialObjectStructure from "../../FormModel/InitialObjectStructure.json";
import validationSchema from "../../FormModel/validationSchema";
import { WidgetEnum } from "../../Store/WidgetEnum";
import BankAccountDetails from "../Widgets/BankAccountVerification/BankAccountDetails";
import { FormikPatchTouched } from "../../Utils/FormikPatchTouched";

//TabPanel Component for display that corresponding tab's content
function TabPanel(props) {
  const { children, value, index } = props;

  return <>{value === index && <>{children}</>}</>;
}
function BankAccountVerificationForm(props) {
  const { t } = useTranslation("common");
  const [value, setValue] = useState(0);
  const [currentValidationSchema, setCurrentValidationSchema] = useState(
    getFormValidationSchema()
  );

  // get the form validation schema based on the current widget
  function getFormValidationSchema() {
    var widgetValidationSchema = _.find(
      validationSchema,
      (obj) => obj.widgetShortName === WidgetEnum.BANKVF
    );

    return widgetValidationSchema.validationSchemaObj;

  }
  // handle submit
  function _handleSubmit(values, actions) {
    props.onSubmit(values).then(
      (res) => {
        // operations to be dont on submit to avoid issues
        actions.setTouched({});
        actions.setSubmitting(false);
      },
      (error) => {
        actions.setSubmitting(false);
      }
    );
  }

  // tasks to be performed on clicking the back button
  function _handleBack(event,values) {
    event.preventDefault();
    props.onBack(values);       
  }

    // maintain the current Tab object
    const isActive = (selectedtab) => {
      return (
        " tab_panel_button " +
        (value !== null && value !== undefined && value === selectedtab
          ? "tabactive"
          : "tab_panel_button")
      );
    };
  
    // assign  selected tab
    const assignTab = (e, obj) => {
      e.preventDefault();
  
      setValue(obj)
    };
  

  return (
    <>
      <Formik
        initialValues={props.value || InitialObjectStructure}
        validationSchema={currentValidationSchema}
        onSubmit={_handleSubmit}
        enableReinitialize={true}
        noValidate={true}
      >
        {({ isSubmitting, errors, values, handleChange }) => (
          <Form id="BankVerificationForm" autoComplete="off" noValidate={true}>
           <FormikPatchTouched/>
            <Tabs
              variant="scrollable"
              value={value}
              scrollButtons="auto"
              allowScrollButtonsMobile
              className="tab_panel"
            >
              <Tab
                label={t("bankdetails.bankAccountDetails")}
                id="tab_panel_button"
                onClick={(event) => assignTab(event, 0)}
                value={0}
                className={isActive(0)}
              ></Tab>
            </Tabs>
            <TabPanel value={value} index={0}>
              <BankAccountDetails onNext={props.onNext} />
            </TabPanel>

            {errors && console.log(errors)}
            {/* When ever form data changes then raise on change props with values */}
            {props.onChange(values)}
            <div className="action_bar d-flex justify-content-between py-2">
              <div>
                <Button
                  className="btn shadow-none action_btn"
                  onClick={(event) => _handleBack(event, values)}
                >
                  {" "}
                  {t("form.back")}{" "}
                </Button>
              </div>
              <div>
                <Button
                  className="btn shadow-none action_btn me-2"
                  disabled={isSubmitting}
                  type="submit"
                >
                  {" "}
                  {t("form.next")}{" "}
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
export default BankAccountVerificationForm;
